export default __webpack_public_path__ + "static/media/onboarding_2.3e58a9f2.png";